module.exports = __webpack_public_path__ + "img/fullscreen-24px.546ed0de.svg";